/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_CompressInputs */

const en_shortcut_keys_desc_compress = /** @type {(inputs: Shortcut_Keys_Desc_CompressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compress the event text vertically`)
};

const fr_shortcut_keys_desc_compress = /** @type {(inputs: Shortcut_Keys_Desc_CompressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compresser le texte de l'evenement verticalement`)
};

const de_shortcut_keys_desc_compress = /** @type {(inputs: Shortcut_Keys_Desc_CompressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Den Ereignistext vertikal komprimieren`)
};

const it_shortcut_keys_desc_compress = /** @type {(inputs: Shortcut_Keys_Desc_CompressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprimi verticalmente il testo dell'evento`)
};

const ru_shortcut_keys_desc_compress = /** @type {(inputs: Shortcut_Keys_Desc_CompressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сожмите текст события по вертикали`)
};

const es_shortcut_keys_desc_compress = /** @type {(inputs: Shortcut_Keys_Desc_CompressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprimir el texto del evento verticalmente`)
};

const zh_cn2_shortcut_keys_desc_compress = /** @type {(inputs: Shortcut_Keys_Desc_CompressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`垂直压缩事件文本`)
};

const ja_shortcut_keys_desc_compress = /** @type {(inputs: Shortcut_Keys_Desc_CompressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントテキストを縦に圧縮する`)
};

const hi_shortcut_keys_desc_compress = /** @type {(inputs: Shortcut_Keys_Desc_CompressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट टेक्स्ट को लंबवत रूप से संपीड़ित करें`)
};

const pt_pt2_shortcut_keys_desc_compress = /** @type {(inputs: Shortcut_Keys_Desc_CompressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprima o texto do evento verticalmente.`)
};

/**
* | output |
* | --- |
* | "Compress the event text vertically" |
*
* @param {Shortcut_Keys_Desc_CompressInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_compress = /** @type {((inputs?: Shortcut_Keys_Desc_CompressInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_CompressInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_compress(inputs)
	if (locale === "de") return de_shortcut_keys_desc_compress(inputs)
	if (locale === "it") return it_shortcut_keys_desc_compress(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_compress(inputs)
	if (locale === "es") return es_shortcut_keys_desc_compress(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_compress(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_compress(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_compress(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_compress(inputs)
	return en_shortcut_keys_desc_compress(inputs)
});